import { observer } from "mobx-react-lite";

import { Dialog, Heading } from "@bps/fluent-ui";
import { useDialogOpenedAnalytics } from "@libs/analytics/hooks/useDialogOpenedAnalytics.ts";
import { Permission } from "@libs/gateways/core/CoreGateway.dtos.ts";
import { AppointmentInformationModalContext } from "@modules/booking/screens/booking-calendar/components/appointment-dialog/components/appointment-form/appointment-information/AppointmentInformationModalContext.ts";
import { AppointmentInformationModalHelper } from "@modules/booking/screens/booking-calendar/components/appointment-dialog/components/appointment-form/appointment-information/AppointmentInformationModalHelper.ts";
import { useStores } from "@stores/hooks/useStores.ts";
import { usePersistedHelper } from "@ui-components/hooks/usePersistedHelper.ts";

import { AppointmentInformationModalInner } from "./AppointmentInformationModalInner.tsx";
import { AppointmentInformationModalPrintWrapper } from "./AppointmentInformationModalPrintWrapper.tsx";
import { AppointmentInformationModalInnerOld } from "./old/AppointmentInformationModalInnerOld.tsx";

const AppointmentInformationModal = observer(() => {
  const root = useStores();
  const helper = usePersistedHelper(
    () => new AppointmentInformationModalHelper(root)
  );

  const settings = root.booking.ui.appointmentInformationModalSettings;

  useDialogOpenedAnalytics(
    "Appointment information dialog",
    root.core.user?.fullName,
    !!settings
  );

  if (!settings) return null;

  const { contactId, claimId } = settings;

  const contact = root.practice.contactsMap.get(contactId);
  const claim = claimId ? root.acc.claimsMap.get(claimId) : undefined;

  const title = (
    <Heading variant="modal-heading">
      Appointment information for {contact?.fullName}{" "}
      {claim && `- ${claim.claimNumber ?? ""}`}
    </Heading>
  );

  const onDismissInfoModal = () =>
    root.booking.ui.setAppointmentInformationModalSettings(undefined);

  return (
    <Dialog
      hidden={false}
      onDismiss={onDismissInfoModal}
      dialogContentProps={{
        title,
        showCloseButton: true,
        styles: {
          content: { height: "100%" },
          inner: {
            paddingLeft: 24,
            paddingRight: 24
          }
        }
      }}
      minWidth={1200}
    >
      <AppointmentInformationModalContext.Provider value={helper}>
        <AppointmentInformationModalPrintWrapper title={title}>
          {root.core.hasPermissions(Permission.ApptTablePaginationPrerel) ? (
            <AppointmentInformationModalInner
              contactId={contactId}
              onDismissInfoModal={onDismissInfoModal}
              claimId={claimId}
            />
          ) : (
            <AppointmentInformationModalInnerOld
              contactId={contactId}
              onDismissInfoModal={onDismissInfoModal}
              claimId={claimId}
            />
          )}
        </AppointmentInformationModalPrintWrapper>
      </AppointmentInformationModalContext.Provider>
    </Dialog>
  );
});

// eslint-disable-next-line import/no-default-export
export default AppointmentInformationModal;
